import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/router";
import { setUser, clearUser } from "./auth/authSlice";
import { API_BASE_URL } from "./constants";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchUser = async () => {
      if (token) {
        try {
          const response = await fetch(`${API_BASE_URL}/user`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (!response.ok) {
            throw new Error("Failed to fetch user");
          }

          const userData = await response.json();
          dispatch(setUser(userData)); // Store user data in Redux
        } catch (error) {
          localStorage.removeItem("token"); // Clear invalid token
          dispatch(clearUser()); // Clear user state in Redux
        }
      } else {
        dispatch(clearUser());
      }
    };

    fetchUser();
  }, [dispatch]);

  return <RouterProvider router={router} />;
}

export default App;
